// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-section {
    text-align: center;
    width: 100%;
    margin-bottom: 40px;
    margin-top: 80px;
  }

  .about-page-main-image {
    width: 95%;
height: 424px;
    margin-bottom: 20px;
    margin-top: 70px;
  }

  .about-section-title-style {
    font-size: 48px;
    font-weight: 700;
    font-family: "Plus Jakarta Sans", serif;
    color: #000000;
    text-align: center;
  }

  .about-section-sub-title-style {
    text-align: center;
    max-width: 900px;  /* Adjust width as needed */
    margin: 0 auto;  /* Centers the element */
    font-size: 22px;
    font-weight: 500;
    color: #6C757D;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* Limits to 2 lines */
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: 64px;
    margin-top: 32px;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/AboutUs/Component/AboutImage/aboutImage.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,UAAU;AACd,aAAa;IACT,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,uCAAuC;IACvC,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB,GAAG,2BAA2B;IAC9C,cAAc,GAAG,wBAAwB;IACzC,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,qBAAqB,EAAE,sBAAsB;IAC7C,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;EAClB","sourcesContent":[".about-section {\n    text-align: center;\n    width: 100%;\n    margin-bottom: 40px;\n    margin-top: 80px;\n  }\n\n  .about-page-main-image {\n    width: 95%;\nheight: 424px;\n    margin-bottom: 20px;\n    margin-top: 70px;\n  }\n\n  .about-section-title-style {\n    font-size: 48px;\n    font-weight: 700;\n    font-family: \"Plus Jakarta Sans\", serif;\n    color: #000000;\n    text-align: center;\n  }\n\n  .about-section-sub-title-style {\n    text-align: center;\n    max-width: 900px;  /* Adjust width as needed */\n    margin: 0 auto;  /* Centers the element */\n    font-size: 22px;\n    font-weight: 500;\n    color: #6C757D;\n    display: -webkit-box;\n    -webkit-line-clamp: 2; /* Limits to 2 lines */\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    margin-bottom: 64px;\n    margin-top: 32px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
